import { render, staticRenderFns } from "./CardPaymentConfigCreate.vue?vue&type=template&id=01c56971"
import script from "./CardPaymentConfigCreate.vue?vue&type=script&lang=js"
export * from "./CardPaymentConfigCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports